import {
  CROP_CHANGE_PLAN_INDEX,
  CROP_FERTILIZATION_PLAN,
  CROP_FIELD_HISTORY,
  CROP_FIELDS_AND_WORKS_INDEX,
  CROP_YIELD_ACCOUNTING_INDEX,
  EQUIPMENT_LIST_INDEX,
  EQUIPMENT_MAINTENANCE_INDEX,
  FINANCE_ANALYSIS_INDEX,
  FINANCE_BUDGET_INDEX,
  FINANCE_MODELING_INDEX,
  HUMAN_EMPLOYEES_INDEX,
  HUMAN_PARTNERS_INDEX,
  WAREHOUSE_MOVEMENT_INDEX,
  WAREHOUSE_PRODUCTS_INDEX,
  WAREHOUSE_WAREHOUSES_INDEX,
  LIVESTOCK_ANIMALS_AND_EVENTS_INDEX,
  LIVESTOCK_FODDER_NEED_INDEX,
  REPORTING_REPORT_JOURNALS_INDEX,
  REPORTING_VAAD_LIZ_REPORTS,
  REPORTING_BIOLOGICAL_FARMING_INDEX,
  LIVESTOCK_SUMMARY_INDEX,
  DOCUMENT_STORAGE_INDEX,
  LIVESTOCK_BARN_INDEX,
} from '../../router/routes';
import {
  faAnalytics,
  faArrowsAltH,
  faBoxes,
  faBriefcase,
  faChartPie,
  faClipboardCheck,
  faCoins,
  faCow,
  faFileAlt,
  faFileSpreadsheet,
  faHistory,
  faList,
  faPrescriptionBottle,
  faSeedling,
  faTractor,
  faUsers,
  faWarehouse,
  faWheat,
  faWrench,
  IconDefinition,
  faCorn,
  faChartLine,
  faHandHoldingSeedling,
  faFolderOpen,
} from '@fortawesome/pro-solid-svg-icons';
import barnIcon from '../../assets/icons/barn_icon';
import { can } from '../../services/utils';
import { MovementType } from '../../pages/warehouse/movement';
import { ProductObtainType } from '../../enums/product-obtain-type';
import { Section as FieldsAndWorksSection } from '../../pages/crop/fields-and-works';
import { TabKey as FieldHistorySection } from '../../pages/crop/field-history';
import { TabKey as YieldAccountingSection } from '../../pages/crop/yield-accounting';
import { EquipmentType } from '../../enums/equipment-type';
import Classifier from '../../enums/classifier';
import { FarmUser } from '../../interfaces/farm-user';
import AnimalsAndEventsTabKeys from '../../pages/livestock/animals-and-events/enums/animals-and-events-tab-keys';
import { FertilizationPlanTabKey } from '../../pages/crop/fertilization-plan';
import { BudgetsType } from '../../pages/finance/budget';
import { TabKey as LivestockSummarySection } from '../../pages/livestock/livestock-summary';
import { DocumentStorageTypes } from '../../enums/document-storage-type';

export interface sidebarMenuListItem {
  label: string;
  icon: IconDefinition;
  link: string;
  params?: any;
  ability?: {
    entity_type: string;
  };
  isActive?: boolean;
}

export interface sidebarGroupItem {
  key: string;
  heading: {
    title: string;
    icon: IconDefinition;
  };
  color: string;
  colorHover: string;
  isActive?: boolean;
  items: sidebarMenuListItem[];
}

export const menu: sidebarGroupItem[] = [
  {
    key: 'crop',
    heading: { title: 'components.sidebar.crop.title', icon: faWheat },
    color: '#50AE2F',
    colorHover: '#3E9A21',
    items: [
      {
        label: 'components.sidebar.crop.fields-and-works',
        icon: faClipboardCheck,
        link: CROP_FIELDS_AND_WORKS_INDEX,
        params: { tab: FieldsAndWorksSection.fields },
        ability: { entity_type: 'field' },
      },
      {
        label: 'components.sidebar.crop.yield-accounting',
        icon: faWheat,
        link: CROP_YIELD_ACCOUNTING_INDEX,
        params: { tab: YieldAccountingSection.GRAINS },
        ability: { entity_type: 'yield_accounting' },
      },
      {
        label: 'components.sidebar.crop.field-history',
        icon: faHistory,
        link: CROP_FIELD_HISTORY,
        params: { tab: FieldHistorySection.HISTORY },
        ability: { entity_type: 'field_history' },
      },
      {
        label: 'components.sidebar.crop.crop-change-plan',
        icon: faSeedling,
        link: CROP_CHANGE_PLAN_INDEX,
        ability: { entity_type: 'crop_change_plan' },
      },
      {
        label: 'components.sidebar.crop.fertilization-plan',
        icon: faPrescriptionBottle,
        link: CROP_FERTILIZATION_PLAN,
        params: { tab: FertilizationPlanTabKey.PLAN },
        ability: { entity_type: 'fertilization_plan' },
      },
    ],
  },
  {
    key: 'livestock',
    heading: { title: 'components.sidebar.livestock.title', icon: faCow },
    color: '#12589F',
    colorHover: '#19508B',
    items: [
      {
        label: 'components.sidebar.livestock.animals_and_events',
        icon: faCow,
        link: LIVESTOCK_ANIMALS_AND_EVENTS_INDEX,
        ability: { entity_type: 'animal' },
        params: { tab: AnimalsAndEventsTabKeys.animals },
      },
      {
        label: 'components.sidebar.livestock.fodder_need',
        icon: faCorn,
        link: LIVESTOCK_FODDER_NEED_INDEX,
        ability: { entity_type: 'fodder_need' },
      },
      {
        label: 'components.sidebar.livestock.summary',
        icon: faChartPie,
        link: LIVESTOCK_SUMMARY_INDEX,
        params: { tab: LivestockSummarySection.DAIRY },
        ability: { entity_type: 'livestock_summary' },
      },
      {
        label: 'components.sidebar.livestock.barn',
        icon: barnIcon,
        link: LIVESTOCK_BARN_INDEX,
        ability: { entity_type: 'barn' },
      },
    ],
  },
  {
    key: 'warehouse',
    heading: {
      title: 'components.sidebar.warehouse.title',
      icon: faWarehouse,
    },
    color: '#C23A93',
    colorHover: '#B23687',
    items: [
      {
        label: 'components.sidebar.warehouse.movement',
        icon: faArrowsAltH,
        link: WAREHOUSE_MOVEMENT_INDEX,
        params: { tab: MovementType.deals },
        ability: { entity_type: 'deal' },
      },
      {
        label: 'components.sidebar.warehouse.products',
        icon: faBoxes,
        link: WAREHOUSE_PRODUCTS_INDEX,
        params: { obtainTypeId: ProductObtainType.PRODUCED },
        ability: { entity_type: 'product' },
      },
      {
        label: 'components.sidebar.warehouse.warehouses',
        icon: faWarehouse,
        link: WAREHOUSE_WAREHOUSES_INDEX,
        ability: { entity_type: 'warehouse' },
      },
    ],
  },
  {
    key: 'human',
    heading: {
      title: 'components.sidebar.human.title',
      icon: faUsers,
    },
    color: '#BC5A6F',
    colorHover: '#A5475B',
    items: [
      {
        label: 'components.sidebar.human.employees',
        icon: faUsers,
        link: HUMAN_EMPLOYEES_INDEX,
        ability: { entity_type: 'employee' },
      },
      {
        label: 'components.sidebar.human.partners',
        icon: faBriefcase,
        link: HUMAN_PARTNERS_INDEX,
        ability: { entity_type: 'partner' },
      },
    ],
  },
  {
    key: 'document',
    heading: {
      title: 'components.sidebar.document_storage.title',
      icon: faFolderOpen,
    },
    color: '#77353D',
    colorHover: '#A5475B',
    items: [
      {
        label: 'components.sidebar.document_storage.warehouse',
        icon: faWarehouse,
        link: DOCUMENT_STORAGE_INDEX,
        ability: { entity_type: 'document_storage_warehouse' },
        params: { tab: DocumentStorageTypes.WAREHOUSE },
      },
      {
        label: 'components.sidebar.document_storage.crop',
        icon: faWheat,
        link: DOCUMENT_STORAGE_INDEX,
        ability: { entity_type: 'document_storage_crop' },
        params: { tab: DocumentStorageTypes.CROP },
      },
      {
        label: 'components.sidebar.document_storage.livestock',
        icon: faCow,
        link: DOCUMENT_STORAGE_INDEX,
        ability: { entity_type: 'document_storage_livestock' },
        params: { tab: DocumentStorageTypes.LIVESTOCK },
      },
      {
        label: 'components.sidebar.document_storage.my_documents',
        icon: faFolderOpen,
        link: DOCUMENT_STORAGE_INDEX,
        ability: { entity_type: 'document_storage_my_documents' },
        params: { tab: DocumentStorageTypes.MY_DOCUMENTS },
      },
    ],
  },
  {
    key: 'finance',
    heading: {
      title: 'components.sidebar.finance.title',
      icon: faCoins,
    },
    color: '#E2934C',
    colorHover: '#E2934C',
    items: [
      {
        label: 'components.sidebar.finance.production-cost-analysis',
        icon: faAnalytics,
        link: FINANCE_ANALYSIS_INDEX,
        // todo: create or remove if is public
        ability: { entity_type: 'production_cost_analysis' },
      },
      {
        label: 'components.sidebar.finance.budget',
        icon: faChartPie,
        link: FINANCE_BUDGET_INDEX,
        params: { tab: BudgetsType.crop },
        ability: { entity_type: 'budget' },
      },
      {
        label: 'components.sidebar.finance.production-modeling',
        icon: faFileSpreadsheet,
        link: FINANCE_MODELING_INDEX,
        params: { type: Classifier.CROP_PRODUCTION_MODELS },
      },
    ],
  },
  {
    key: 'equipment',
    heading: {
      title: 'components.sidebar.equipment.title',
      icon: faTractor,
    },
    color: '#608A99',
    colorHover: '#517C8B',
    items: [
      {
        label: 'components.sidebar.equipment.list',
        icon: faList,
        link: EQUIPMENT_LIST_INDEX,
        params: {
          equipmentType: EquipmentType.selfPropelledMachinery, // default to select
        },
        ability: { entity_type: 'equipment' },
      },
      {
        label: 'components.sidebar.equipment.maintenance',
        icon: faWrench,
        link: EQUIPMENT_MAINTENANCE_INDEX,
        ability: { entity_type: 'maintenance' },
      },
      // {
      //   label: 'components.sidebar.equipment.fuel-consumption',
      //   icon: faGasPump,
      //   link: EQUIPMENT_FUEL_CONSUMPTION,
      //   ability: { entity_type: 'maintenance' },
      // },
    ],
  },
  {
    key: 'reports',
    heading: {
      title: 'components.sidebar.reports.title',
      icon: faChartLine,
    },
    color: '#088F8F',
    colorHover: '#058484',
    items: [
      {
        label: 'components.sidebar.reports.biological_farming',
        icon: faHandHoldingSeedling,
        link: REPORTING_BIOLOGICAL_FARMING_INDEX,
        ability: { entity_type: 'biological_farming' },
      },
      {
        label: 'components.sidebar.reports.vaad_liz_reports',
        icon: faFileAlt,
        link: REPORTING_VAAD_LIZ_REPORTS,
        params: { year: new Date().getFullYear() },
        ability: { entity_type: 'vaad_liz_reports' },
      },
      {
        label: 'components.sidebar.reports.report-journals',
        icon: faFileAlt,
        link: REPORTING_REPORT_JOURNALS_INDEX,
        ability: { entity_type: 'report_journal' },
      },
    ],
  },
];

export function buildMenu(farmUser: FarmUser, sectors: string[]) {
  return menu
    .map((item) => {
      const builtItems = item.items
        .map((subItems: sidebarMenuListItem) => {
          return can(farmUser, subItems.ability) ? subItems : null;
        })
        .filter(Boolean);
      return builtItems.length ? { ...item, items: builtItems } : null;
    })
    .filter((group) => {
      switch (group?.key) {
        case 'warehouse':
        case 'crop':
        case 'livestock':
          return sectors.includes(group?.key);
        case 'human':
          return sectors.includes('warehouse');
        default:
          return true;
      }
    })
    .filter(Boolean);
}
